import { Check, FileText } from 'lucide-react'

/**
 * AgreementChecklist — s101 (D496). The agreements a share asks for, each with "Read it" and its own
 * "I agree" tick: Orella's always; the physician's own when they ask for it. One signature follows.
 * Without a physician agreement this renders nothing (the sheet is Orella's alone, as before).
 */
export default function AgreementChecklist({ practice, agreeOrella, setAgreeOrella, agreePractice, setAgreePractice, onReadOrella, onReadPractice, doctorName, t }) {
  if (!practice) return null
  const tr = (k, d, o) => (t ? t(k, { defaultValue: d, ...(o || {}) }) : d)
  const orellaTitle = tr('agreement.orellaTitle', 'Orella Platform Agreement')
  const practiceTitle = practice.title || tr('agreement.practiceFallback', "Your doctor's patient agreement")
  const Row = ({ title, from, on, toggle, read, testid }) => (
    <div className="rounded-xl border border-[#E5EDF3] bg-white p-3 flex flex-col gap-1.5" data-testid={testid}>
      <b className="text-[14px] text-[#15354F]">{title}</b>
      <span className="text-[12px] text-[#5E7385]">{from}</span>
      <button type="button" onClick={read} className="self-start flex items-center gap-1 text-[13px] font-bold text-[#46A8F9]">
        <FileText size={13} /> {tr('agreement.readIt', 'Read it')}
      </button>
      <button type="button" onClick={toggle} className="flex items-start gap-2.5 text-left text-[13px] text-[#15354F]" aria-pressed={on}>
        <span className="w-5 h-5 rounded-md flex-none flex items-center justify-center mt-px"
          style={on ? { background: '#16A34A', border: '1.5px solid #16A34A' } : { border: '1.5px solid #CBD5E1', background: '#fff' }}>
          {on && <Check size={13} color="#fff" />}
        </span>
        <span>{tr('agreement.iAgreeTo', 'I have read and agree to the {{title}}', { title })}</span>
      </button>
    </div>
  )
  return (
    <div className="flex flex-col gap-2.5 mb-3" data-testid="agreement-checklist">
      <p className="text-[13px] text-[#15354F]">{tr('agreement.bothBefore', 'Before {{name}} receives your case, please read and agree to both.', { name: doctorName || tr('agreement.yourDoctor', 'your doctor') })}</p>
      <Row title={orellaTitle} from={tr('agreement.fromOrella', 'From Orella')} on={agreeOrella} toggle={() => setAgreeOrella(!agreeOrella)} read={onReadOrella} testid="agreement-row-orella" />
      <Row title={practiceTitle} from={practice.practice || practice.provider || ''} on={agreePractice} toggle={() => setAgreePractice(!agreePractice)} read={onReadPractice} testid="agreement-row-practice" />
      <p className="text-[11px] font-bold uppercase tracking-[.08em] text-[#5E7385] mt-1">{tr('agreement.signOnce', 'Sign once for both')}</p>
    </div>
  )
}
